import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as r } from "../chunks/tslib.es6.js";
import e from "./Accessor.js";
import s from "./Collection.js";
import { assumeNonNull as t } from "./maybe.js";
import { property as o } from "./accessorSupport/decorators/property.js";
import { subclass as i } from "./accessorSupport/decorators/subclass.js";

var h = /*#__PURE__*/function (_e) {
  _inherits(h, _e);

  var _super = _createSuper(h);

  function h(r) {
    var _this;

    _classCallCheck(this, h);

    _this = _super.call(this, r), _this._groups = new Map();
    return _this;
  }

  _createClass(h, [{
    key: "destroy",
    value: function destroy() {
      this.removeAll();
    }
  }, {
    key: "size",
    get: function get() {
      var r = 0;
      return this._groups.forEach(function (e) {
        r += e.length;
      }), r;
    }
  }, {
    key: "add",
    value: function add(r, e) {
      var _this2 = this;

      if (!this._isHandle(r) && !Array.isArray(r) && !s.isCollection(r)) return this;

      var t = this._getOrCreateGroup(e);

      return Array.isArray(r) || s.isCollection(r) ? r.forEach(function (r) {
        return _this2._isHandle(r) && t.push(r);
      }) : t.push(r), this.notifyChange("size"), this;
    }
  }, {
    key: "forEach",
    value: function forEach(r, e) {
      if ("function" == typeof r) this._groups.forEach(function (e) {
        return e.forEach(r);
      });else {
        var _s = this._getGroup(r);

        _s && e && _s.forEach(e);
      }
    }
  }, {
    key: "has",
    value: function has(r) {
      return this._groups.has(this._ensureGroupKey(r));
    }
  }, {
    key: "remove",
    value: function remove(r) {
      if (Array.isArray(r) || s.isCollection(r)) return r.forEach(this.remove, this), this;
      if (!this.has(r)) return this;

      var e = this._getGroup(r);

      for (var _s2 = 0; _s2 < e.length; _s2++) {
        e[_s2].remove();
      }

      return this._deleteGroup(r), this.notifyChange("size"), this;
    }
  }, {
    key: "removeAll",
    value: function removeAll() {
      return this._groups.forEach(function (r) {
        for (var _e2 = 0; _e2 < r.length; _e2++) {
          r[_e2].remove();
        }
      }), this._groups.clear(), this.notifyChange("size"), this;
    }
  }, {
    key: "_isHandle",
    value: function _isHandle(r) {
      return r && !!r.remove;
    }
  }, {
    key: "_getOrCreateGroup",
    value: function _getOrCreateGroup(r) {
      if (this.has(r)) return this._getGroup(r);
      var e = [];
      return this._groups.set(this._ensureGroupKey(r), e), e;
    }
  }, {
    key: "_getGroup",
    value: function _getGroup(r) {
      return t(this._groups.get(this._ensureGroupKey(r)));
    }
  }, {
    key: "_deleteGroup",
    value: function _deleteGroup(r) {
      return this._groups.delete(this._ensureGroupKey(r));
    }
  }, {
    key: "_ensureGroupKey",
    value: function _ensureGroupKey(r) {
      return r || "_default_";
    }
  }]);

  return h;
}(e);

r([o({
  readOnly: !0
})], h.prototype, "size", null), h = r([i("esri.core.Handles")], h);
var u = h;
export { u as default };